import type React from 'react'
import { Button, Menu, MenuTrigger, Popover } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'

import { navbarItem } from '../styles/recipe'

export function DropdownMenu({ children }: React.PropsWithChildren) {
    const { i18n } = useI18n()
    const classes = navbarItem()

    return (
        <MenuTrigger>
            <Button className={classes.content}>
                <i className="fa-solid fa-bars" />
                &nbsp;{i18n.BUTTON_HAMBURGER_MENU}&nbsp;
                <i className={cx('fa-solid fa-caret-down', css({ fontSize: 'xs' }))} />
            </Button>
            <Popover offset={-1} className={css({ position: 'relative' })}>
                <Menu
                    className={css({
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        right: '[auto]',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        backgroundColor: 'white',
                        color: 'gray.600',
                        paddingY: '2',
                        borderRadius: 'md',
                        minWidth: '[160px]',
                        border: '[1px solid rgba(0, 0, 0, 0.15)]',
                        _focusVisible: { outline: 'none' },
                    })}
                >
                    {children}
                </Menu>
            </Popover>
        </MenuTrigger>
    )
}
